import { useFormContext } from 'react-hook-form';

import { PayrunTypes } from '@xemplo/gp-types';
import { useListBuilder } from '@xemplo/stateful-list-core';
import { V2 } from '@xemplo/text-dropdown';

import { FormFields } from '../../../create-amendment.types';
import * as S from '../../modal.styles';

export function PayrunType() {
  const { unregister } = useFormContext<FormFields>();
  const payrunTypeList = useListBuilder(payrunTypeItems);

  return (
    <S.FormLabel>
      Pay run type
      <V2.TextDropdownRhf
        name="payrunType"
        items={payrunTypeList}
        placeholder="Select payrun type"
        aria-label="Pay run type"
        rules={{
          deps: ['changeType'],
          required: 'This field is required',
        }}
        onChange={(value) => {
          if (value === PayrunTypes.ADHOC) {
            unregister('payrun');
          } else if (value === PayrunTypes.SCHEDULED) {
            unregister('adhocEffectiveDate');
            unregister('adhocPayDate');
          }
        }}
      />
    </S.FormLabel>
  );
}

const payrunTypeItems = [
  {
    key: PayrunTypes.ADHOC,
    value: 'Adhoc',
  },
  {
    key: PayrunTypes.SCHEDULED,
    value: 'Scheduled',
  },
];
